import type { DetectedTrend } from '@vitalai/health-models';

const TREND_ICON: Record<DetectedTrend['type'], string> = {
  hrv_declining: '↓',
  resting_hr_rising: '↑',
  sleep_debt: '◔',
  later_bedtime: '◑',
  lower_recovery: '⚠',
  overtraining_signal: '⚠',
  nutrition_deficit: '◔',
};

export function TrendCard({ trend }: { trend: DetectedTrend }) {
  return (
    <div className={`trend-card trend-card--${trend.severity}`}>
      <span className="trend-card__icon" aria-hidden="true">
        {TREND_ICON[trend.type] ?? '•'}
      </span>
      <p className="trend-card__message">{trend.message}</p>
    </div>
  );
}
